import { AdminLayout } from "@/components/layout/AdminLayout";
import LoginPage from "@/pages/auth/LoginPage";
import UsersPage from "@/pages/admin/users/UsersPage";
import UserDetailPage from "@/pages/admin/users/UserDetailPage";
import OrdersPage from "@/pages/admin/orders/OrdersPage";
import GoalSchemesPage from "@/pages/admin/goals/GoalSchemesPage";
import AssetBasedFundsPage from "@/pages/admin/assetBasedFunds/AssetBasedFundsPage";
import NotificationsPage from "@/pages/admin/notifications/NotificationsPage";
import CreateNotificationPage from "@/pages/admin/notifications/CreateNotificationPage";
import ViewNotificationPage from "@/pages/admin/notifications/ViewNotificationPage";
import InflationConfigPage from "@/pages/admin/inflation/InflationConfigPage";
import ReconciliationHistoryPage from "@/pages/admin/reconciliation/ReconciliationHistoryPage";
import ServerConfigPage from "@/pages/admin/server-config/ServerConfigPage";
import ProfilePage from "@/pages/admin/profile/ProfilePage";
import NotFoundPage from "@/pages/NotFoundPage";
import { Route, Routes, Navigate } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" replace />} />

      <Route path="/login" element={<LoginPage />} />

      {/* Admin routes */}
      <Route
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/home" element={<UsersPage />} />
        <Route path="/users/:id" element={<UserDetailPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/goals" element={<GoalSchemesPage />} />
        <Route path="/asset-based-funds" element={<AssetBasedFundsPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/notifications/create" element={<CreateNotificationPage />} />
        <Route path="/notifications/:id" element={<ViewNotificationPage />} />
        <Route path="/inflation" element={<InflationConfigPage />} />
        <Route path="/reconciliation" element={<ReconciliationHistoryPage />} />
        <Route path="/server-config" element={<ServerConfigPage />} />
        <Route path="/profile" element={<ProfilePage />} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default AppRoutes;
